// extracted by mini-css-extract-plugin
export default {"ColorsContainer":"ThemeCreator_ColorsContainer__7dvzm"};